
import { useState, useEffect, useContext, createContext } from "react";

import { fetchSubjectsMetadata } from "../utilities/server-fetch";

// TODO: See RibonSubjectsContext.tsx LARGE COMMENT for future potential Refactor
//import { SubjectsMetadataSubjectsContextProvider } from "./SubjectsMetadataSubjectsContext";

import { SubjectSelector, SubjectTypeSelector } from "@Beasted1010/pivotal-wisdom";


export {
  SubjectsMetadataContextProvider,
  useSubjectsMetadata, useSubjectsMetadataUpdate
};


const SubjectsMetadataContext = createContext<any>( null ); // TODO: Properly fill out ??

const SubjectsMetadataUpdateContext = createContext<any>( null ); // TODO: Properly fill out ??


function useSubjectsMetadata() {
  return useContext( SubjectsMetadataContext );
}

function useSubjectsMetadataUpdate() {
  return useContext( SubjectsMetadataUpdateContext );
}




function SubjectsMetadataContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [specialtySubjectsMetadata, setSpecialtySubjectsMetadata] = useState<ISubjectMetadata[]>( [] );
  const [foundationSubjectsMetadata, setFoundationSubjectsMetadata] = useState<ISubjectMetadata[]>( [] );


  useEffect( () => {

    const abortController = new AbortController();

    const getSubjectsMetadataData = async () => {
      const knownSubjects = Object.values(SubjectSelector);
      const orderSubjects = getOrderSubjectsSortFunction( knownSubjects );

      // Set Specialty Subjects Metadata
      const specialtySubjects: ISubject[] = await fetchSubjectsMetadata({ type: SubjectTypeSelector.SPECIALTY, signal: abortController.signal });

      if( !specialtySubjects ) {
        console.warn( "No Specialty Subjects Metadata Retrieved" );
      }

      specialtySubjects.sort( orderSubjects );
      const specialtyMetadata: ISubjectMetadata[] = populateSubjectsMetadata( specialtySubjects );
      //const specialtyMetadata: ISubject[] = populateSubjectsMetadata( specialtySubjects );
      setSpecialtySubjectsMetadata( specialtyMetadata );

      // Set Foundation Subjects Metadata
      const foundationSubjects: ISubject[] = await fetchSubjectsMetadata({ type: SubjectTypeSelector.FOUNDATION, signal: abortController.signal });

      if( !foundationSubjects ) {
        console.warn( "No Foundation Subjects Metadata Retrieved" );
      }

      foundationSubjects.sort( orderSubjects );
      const foundationMetadata: ISubjectMetadata[] = populateSubjectsMetadata( foundationSubjects );
      //const foundationMetadata: ISubject[] = populateSubjectsMetadata( foundationSubjects );
      setFoundationSubjectsMetadata( foundationMetadata );
    }

    getSubjectsMetadataData();

    return () => {
      abortController.abort();
    }
  }, []);



  // ... Updating State



  // ... Persisting State down into Children
  return (
    <SubjectsMetadataContext.Provider value={ {specialtySubjectsMetadata, foundationSubjectsMetadata} } >
      <SubjectsMetadataUpdateContext.Provider value={ {} } >
        {children}
      </SubjectsMetadataUpdateContext.Provider>
    </SubjectsMetadataContext.Provider>
  )
}


// ================================= HELPERS =================================


function populateSubjectsMetadata( subjects: ISubject[] ) {

  return subjects;

  /*
  return subjects.map( (subject: any) => {
    const subjectType = subject["type"];
    const subjectSelector = subject["selector"];
    const name = subject.name; // TODO: Make others access like this? Instead of [""] Notation?
    const subjectColor = subject["color"];
    const programsData = subject["programs"];

    // NOTE: This works for BOTH Arrays and Objects (not matter if Programs is Array or JSON Object)
    // -- If programsData is an Array, "key" will be the INDEX
    const programs = Object.keys(programsData).map( (key: string) => {
      const programName = programsData[key]["name"];
      const programColor = programsData[key]["color"];
      const programFeatures = programsData[key]["features"].map( (feature: any) => {
        return { type: feature.type };
      });

      return { name: programName, color: programColor, features: programFeatures };
    });

    return { type: subjectType, name, selector: subjectSelector, color: subjectColor, programs };
  });
  */
}


function getOrderSubjectsSortFunction( knownSubjects: string[] ) {
  // For the associated Subject, grab its Index in the SubjectSelector Enum -- ENFORCES ORDER
  // PERFORMANCE CONSIDERATION:
  // -- Sort is O( n log(n) ) Object.values() is O(k) k = # Keys (of top-level only)
  // -- NOT PENALIZED SINCE CLOSURE DEFINES OUTSIDE AS PARAM knownSubjects.indexOf() is O(m) m = length Array

  return function orderSubjects( subjectA: ISubject, subjectB: ISubject ) {

    const aOrder = knownSubjects.includes(subjectA.selector) ? knownSubjects.indexOf(subjectA.selector) : Infinity;
    const bOrder = knownSubjects.includes(subjectB.selector) ? knownSubjects.indexOf(subjectB.selector) : Infinity;

    return aOrder - bOrder; // Ascending Order (Return Value should be Negative if want a go before b)
  }
}






/* */
